// Some people, when confronted with a problem, think ‘I know, I’ll use regular expressions.’ Now they have two problems.
// Jamie Zawinski
// ;-)

(function () {

    'use strict';

    var WHOLE_NUMBER_REGEXP = /^\d+$/;
    var INTEGER_REGEXP = /^\-?\d+$/;


    function createPatternValidator(validatorName, pattern, ngModelCtrl) {
        ngModelCtrl.$validators[validatorName] = function (modelValue, viewValue) {
            if (ngModelCtrl.$isEmpty(modelValue)) {
                // consider empty models to be valid
                return true;
            }

            if (pattern.test(viewValue)) {
                // it is valid
                return true;
            }

            // it is invalid
            return false;
        };
    }


    var naturalNumberValidator = function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {
                createPatternValidator('natural-number', WHOLE_NUMBER_REGEXP, ngModelCtrl);
            }
        };
    }
    angular.module('app').directive('naturalNumber', naturalNumberValidator);


    var integerValidator = function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {
                createPatternValidator('integer', INTEGER_REGEXP, ngModelCtrl);
            }
        };
    }
    angular.module('app').directive('integer', integerValidator);


    // number of decimals position after dot
    // usage: ie. decimals="3" on input field
    var decimalsValidator = function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {

                var decimals = (parseInt(attrs.decimals, 10) > 0) ? parseInt(attrs.decimals, 10) : 2; // two decimals by default
                var decimalsRegexp = new RegExp("^\\-?\\d+(\\.\\d{1," + decimals + "})?$");

                createPatternValidator('decimals', decimalsRegexp, ngModelCtrl);
            }
        };
    }
    angular.module('app').directive('decimals', decimalsValidator);


    // usage <input cannot-contain="word1, word2"
    var cannotContainValidator = function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {

                var pattern = "";
                angular.forEach(attrs.cannotContain.split(','), function (value) {
                    pattern += '(?!^' + value.trim() + '$)';
                });
                pattern = new RegExp('^(' + pattern + '.)*$', 'i'); // we may want to add case-sensitive version based on parameters at some point

                createPatternValidator('cannot-contain', pattern, ngModelCtrl);
            }
        };
    }
    angular.module('app').directive('cannotContain', cannotContainValidator);


    // usage <input match-one="word1, word2"
    var matchOneValidator = function() {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {
                function commaSplitAndTrim(string) {
                    return string.match(/(?=\S)[^,]+?(?=\s*(,|$))/g);
                }
                var pattern = new RegExp('^(' + commaSplitAndTrim(attrs.matchOne).join('|') + ')$', 'i');  // we may want to add case-sensitive version based on parameters at some point
                createPatternValidator('match-one', pattern, ngModelCtrl);
            }
        };
    }
    angular.module('app').directive('matchOne', matchOneValidator);


    // usage <input match-one-dynamic="{{formModel.value}}" (formModel.value must be a string or list of strings separated by comma)
    var matchOneDynamicValidator = function($timeout) {
        return {
            require: ['ngModel', '^form'],
            link: function (scope, elm, attrs, ctrls) {
                var ngModelCtrl = ctrls[0];
                var form = ctrls[1];

                function commaSplitAndTrim(string) {
                    return string.match(/(?=\S)[^,]+?(?=\s*(,|$))/g);
                }

                attrs.$observe('matchOneDynamic', function() {
                    if(attrs.matchOneDynamic){
                        var pattern = new RegExp('^(' + commaSplitAndTrim(attrs.matchOneDynamic).join('|') + ')$', 'i');
                    } else {
                        var pattern = new RegExp('(.*?)');
                    }
                    createPatternValidator('match-one-dynamic', pattern, ngModelCtrl);
                    ngModelCtrl.$validate();
                });
            }
        };
    }
    matchOneDynamicValidator.$inject = ['$timeout'];
    angular.module('app').directive('matchOneDynamic', matchOneDynamicValidator);


    // "should be blank" validator
    var blankValidator = function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {
                // if condition, so it can be used with ng-attr-blank (ie. address-finder)
                // (it generally look as an error - Angular with ng-attr-xxx not removing undefined attribute from attrs and other places)
                if (angular.isDefined(attrs.blank)) {
                    ngModelCtrl.$validators['blank'] = function (modelValue, viewValue) {
                        if (ngModelCtrl.$isEmpty(modelValue)) {
                            // consider empty models to be valid
                            return true;
                        }
                        // it is invalid on any value
                        return false;
                    };
                }
            }
        };
    }
    angular.module('app').directive('blank', blankValidator);

    /**
     * @ngdoc directive
     * @name app.directive:invalidInput
     * @description Invalidates input if input string is equal to invalidInput
     * @param {String} invalidInput (optional) The string to validate against - if not supplied, the input will always be invalid
     unless blank (static error)
     */
    app.directive('invalidInput', function(){
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel){
                scope.$watch(attrs.ngModel, function (newVal) {
                    if(!newVal){
                        ngModel.$setValidity('invalid-input', true);
                    }else if(!attrs.invalidInput){
                        ngModel.$setValidity('invalid-input', false);
                    }else if(newVal !== attrs.invalidInput) {
                        ngModel.$setValidity('invalid-input', true);
                    } else {
                        ngModel.$setValidity('invalid-input', false);
                    }
                });
            }
        };
    });
}());


